import { ScreenerTopTradersParams } from "@api/token-screener/top-traders.ts";
import { createContext, useContext } from "react";

export const getDefaultTopTradersFilters =
  (): ScreenerTopTradersParams["filters"] => {
    return {} as ScreenerTopTradersParams["filters"];
  };

export const TopTradersFilterContext = createContext<{
  filters: ScreenerTopTradersParams["filters"];
  onFiltersUpdate: (filters: ScreenerTopTradersParams["filters"]) => void;
}>({ filters: getDefaultTopTradersFilters(), onFiltersUpdate: () => {} });

export const useTopTradersFilter = () => {
  const context = useContext(TopTradersFilterContext);
  if (!context) {
    throw new Error(
      "useTopTradersFilter must be used within a TopTradersFilterProvider",
    );
  }
  return context;
};
